import React, { useState } from "react"
import { Button, Col, UncontrolledTooltip, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
//components
import ExpandRow from "./ExpandRowProject"
import ProjectInstructionModal from "./ProjectInstructionModal"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

const ProjectTable = props => {
  const {
    handleAddSub,
    row,
    handleEditGroup,
    getallbillingtypes,
    handleSubEditTotalHours,
    isEdit,
    setIsEdit,
    userModal,
    setUserModal,
    activeProject,
    setActiveProject,
    setActiveUser
  } = props
  const [currentPage, setCurrentPage] = useState(1);
  const [instructionProject, setInstructionProject] = useState(null);
  
  const SubHeaderFormatter = (column, colIndex) => {
    return <p>{column.text}</p>
  }

  const HandleAddUser = (item, isEdit, row) => {
    setActiveProject(item);
    setIsEdit(isEdit);
    setUserModal(true);
    if (isEdit) setActiveUser(row);
  }

  const renderBiilableType = (cell, row) => {
    const findBillable = getallbillingtypes?.find(item => item.id === cell)
    return findBillable?.name
  }

  const projectColumns = React.useMemo(
    () => [
      {
        text: "Project",
        dataField: "name",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "15px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        // headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return {
            width: "600px",
            textAlign: "left",
            alignItems: "center",
            paddingBottom: "28px",
          }
        },
      },
      {
        text: "Suspend",
        dataField: "suspend",
        sort: false,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "40px" },

        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left" }
        },
      },
      {
        text: "Restricted User",
        dataField: "restrictbyassigneduser",
        sort: false,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "40px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left" }
        },
      },
      {
        text: "Billable Type",
        dataField: "billingType",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "40px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left", paddingBottom: "28px" }
        },
        formatter: (cellContent, row) => renderBiilableType(cellContent, row),
      },
      {
        text: "Quoted Hours",
        dataField: "quoteHours",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "40px" },
        sortValue: (cell, row) => {
          // Convert the string to a number for sorting
          const numericValue = parseFloat(cell)
          return isNaN(numericValue) ? 0 : numericValue
        },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left", paddingBottom: "28px" }
        },
      },
      {
        text: "Instructions",
        dataField: "projectInstructionAction",
        isDummyField: true,
        formatter: (cell, project) => (
          <Button
            color="link"
            size="sm"
            title="Add or edit project instructions"
            onClick={event => {
              event.stopPropagation()
              setInstructionProject(project)
            }}
          >
            <i className="mdi mdi-information-outline me-1" /> Instructions
          </Button>
        ),
      },
      {
        text: "Action",
        style: { textAlign: "center" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        sort: false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <div role="buttton" style={{ cursor: "Pointer" }}>
            <div
              onClick={e => {
                handleEditGroup(row || {})
              }}
            >
              <span>
                <i
                  className={"mdi mdi-square-edit-outline md-squaree-edit"}
                  id="Edit"
                  style={{ fontSize: "16px" }}
                />
                <UncontrolledTooltip
                  placement="top"
                  target="Edit"
                  className="text-white"
                >
                  Edit
                </UncontrolledTooltip>
              </span>
            </div>
          </div>
        ),
        Cell: cellProps => {
          return <></>
        },
        headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center", pointerEvents: "auto" }
        },
      },
      {
        text: "    ",
        style: { textAlign: "center" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        sort: false,
        formatter: (cellContent, row) => (
          <div role="buttton" style={{ cursor: "Pointer" }}>
            <div
              onClick={e => {
                handleSubEditTotalHours(row || {})
              }}
            >
              <span>
                <i
                  className={"mdi mdi-timelapse md-squaree-edit"}
                  id="Edit"
                  style={{ fontSize: "16px" }}
                />
                <UncontrolledTooltip
                  placement="top"
                  target="Edit"
                  className="text-white"
                >
                  Total Hours
                </UncontrolledTooltip>
              </span>
            </div>
          </div>
        ),
        Cell: cellProps => {
          return <></>
        },
        headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center", pointerEvents: "auto" }
        },
      },
    ],
    []
  )

  const expandRowProjects = {
    renderer: (row) => {
      const userColumns =  [
      {
        text: "First Name",
        dataField: "firstName",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "15px" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        // headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left" }
        },
      },
      {
        text: "Last Name",
        dataField: "lastName",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "10px" },

        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        // headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left" }
        },
      },
      {
        text: "Email",
        dataField: "userEmail",
        sort: true,
        filterable: true,
        style: { textAlign: "left", paddingLeft: "10px" },

        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        // headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "600px", textAlign: "left" }
        },
      },
      {
        text: "Action",
        style: { textAlign: "center" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        sort: false,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, userRow) => (
          <div role="buttton" style={{ cursor: "Pointer" }}>
            <div
              onClick={() => HandleAddUser(row, true, userRow)}
            >
              <span>
                <i
                  className={"mdi mdi-square-edit-outline md-squaree-edit"}
                  id="Edit"
                  style={{ fontSize: "16px" }}
                />
                <UncontrolledTooltip
                  placement="top"
                  target="Edit"
                  className="text-white"
                >
                  Edit
                </UncontrolledTooltip>
              </span>
            </div>
          </div>
        ),
        Cell: cellProps => {
          return <></>
        },
        headerFormatter: SubHeaderFormatter,
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center", pointerEvents: "auto" }
        },
      },
    ]  


      return (
        <div style={{ margin: "0 20px" }}>
          <div className="text-sm-end ">
            <Button
              type="button"
              color="primary"
              onClick={() => HandleAddUser(row)}
              className="btn mb-3 me-2"
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              {"Add New User"}
            </Button>
          </div>
          <ExpandRow
            row={row}
            userColumns={userColumns}
          />
        </div>
      )
    },
    showExpandColumn: true,
    // onlyOneExpanding: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <span />
    },
    // showExpandColumn: true
    expandColumnRenderer: ({ expanded, row }) => {
      if (expanded) {
        return <i className="bx bx-caret-up font-size-20"></i>
      }
      return <i className="bx bx-caret-down font-size-20"></i>
    },
  }

  const sortedDataList = row?.subCategoryList?.sort((a, b) => {
    return new Date(b?.createddate) - new Date(a?.createddate)
  })

  const itemsPerPage = 5;
     
  const totalPages = Math.ceil(sortedDataList.length / itemsPerPage);
  
  const currentItems = sortedDataList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleClick = (pageNumber,event) => {
    event.preventDefault(); 
    setCurrentPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxVisiblePages = 4;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Add the start ellipsis if needed
    if (startPage > 1) {
      paginationItems.push(
        <PaginationItem key="start-ellipsis" disabled>
          <PaginationLink>...</PaginationLink>
        </PaginationItem>
      );
    }

    // Render the page numbers
    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <PaginationItem active={i === currentPage} key={i}>
          <PaginationLink onClick={(e) => handleClick(i,e)} href="#">
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    // Add the end ellipsis if needed
    if (endPage < totalPages) {
      paginationItems.push(
        <PaginationItem key="end-ellipsis" disabled>
          <PaginationLink>...</PaginationLink>
        </PaginationItem>
      );
    }

    return paginationItems;
  };

  return (
    <>
      <div className="d-flex align-items-center breadcrumbtitle">
        <Breadcrumbs title="User Table" breadcrumbItem="Project List" />
        <Col>
          <div className="text-sm-end ">
            <Button
              type="button"
              color="primary"
              className="btn mb-2"
              onClick={handleAddSub}
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              {"Add New Project"}
            </Button>
          </div>
        </Col>
      </div>
      {instructionProject && (
        <ProjectInstructionModal
          project={instructionProject}
          onClose={() => setInstructionProject(null)}
        />
      )}
      <BootstrapTable
        keyField="id"
        data={currentItems || []}
        columns={projectColumns}
        expandRow={expandRowProjects}
        headerClasses="table-light"
        defaultSortDirection="asc"
        noDataIndication="Sorry, There are no data to display"
      />

       <Pagination aria-label="Page navigation example" className="d-flex justify-content-end">
              <PaginationItem disabled={currentPage <= 1}>
                <PaginationLink
                  first
                  onClick={(e) => handleClick(1,e)}
                  href="#"
                />
              </PaginationItem>
              <PaginationItem disabled={currentPage <= 1}>
                <PaginationLink
                  previous
                  onClick={(e) => handleClick(currentPage - 1,e)}
                  href="#"
                />
              </PaginationItem>

               {renderPaginationItems()}

              <PaginationItem disabled={currentPage >= totalPages}>
                <PaginationLink
                  next
                  onClick={(e) => handleClick(currentPage + 1,e)}
                  href="#"
                />
              </PaginationItem>
              <PaginationItem disabled={currentPage >= totalPages}>
                <PaginationLink
                  last
                  onClick={(e) => handleClick(totalPages,e)}
                  href="#"
                />
              </PaginationItem>
            </Pagination>
    </>
  )
}

export default ProjectTable
